<template>
  <div class="table--scroll" v-if="csvRows && csvRows.length > 0">
    <label v-if="hasSearch">
      -
      <input type="search" v-model="searchStr" />
    </label>
    <table>
      <thead>
        <tr>
          <th v-if="hasRowNumbers">#</th>
          <template v-if="columnLabels">
            <th v-for="(label, index) in columnLabels" :key="label" @click="() => setSort(index)">{{ label }}</th>
          </template>
          <template v-if="!columnLabels">
            <th v-for="(column, index) in csvRows[0]" :key="column" @click="() => setSort(index)">{{ column }}</th>
          </template>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, index) in getValueRows(csvRows)" :key="index">
          <td v-if="hasRowNumbers">{{ index + 1 }}</td>
          <td v-for="(column, index) in row" :key="column + index">
            <b v-if="boldedColumns && boldedColumns.includes(index)">{{ column }}</b>
            <a v-else-if="isExternalLink(column)" :href="getLink(column)">{{ getLinkName(column) }}</a>
            <router-link v-else-if="isLink(column) && !isExternalLink(column)" :to="getLink(column)">{{ getLinkName
            (column) }}</router-link>
            <span v-else>{{ column }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Papa from 'papaparse';

export default {
  name: 'DataTable',
  props: {
    csvUrl: {
      type: String,
      required: true,
    },
    hasRowNumbers: {
      type: Boolean,
      required: false,
      default: true,
    },
    hasSearch: {
      type: Boolean,
      default: false,
    },
    columnLabels: {
      type: Array,
      required: false,
    },
    boldedColumns: {
      type: Array,
      required: false,
    },
    sortColumn: {
      type: Number,
      required: false,
      default: null,
    },
    desc: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    csvRows: null,
    searchStr: null,
  }),
  methods: {
    setSort(columnIndex) {
      this.sortColumn = columnIndex;
      this.desc = !this.desc;
    },
    getValueRows(rows) {
      let arr = [...rows];
      if (!this.columnLabels) arr.splice(0, 1);
      if (this.hasSearch && this.searchStr) {
        arr = arr.filter(e => {
          return e.reduce((acc, mut) => `${acc} ${mut.toLowerCase()}`, '').includes(this.searchStr.toLowerCase());
        });
      }
      if (this.sortColumn) {
        arr.sort((e1, e2) => (e1[this.sortColumn] > e2[this.sortColumn] ? (this.desc ? -1 : 1) : this.desc ? 1 : -1));
      }
      return arr;
    },

    isLink(str) {
      return !!str.match(/\[[\w öüä]+\]\([\w=+.\/?&#_%:]+\)/g);
    },
    isExternalLink(str) {
      return !!str.match(/\[[\w öüä]+\]\(https?:\/\/[\w=+.\/?&#_%]+\)/g);
    },
    getLink(str) {
      if (!this.isLink(str)) return '';
      //return str.match(/[\w=+.\/?&#_%:]+/)[0];
      const match = str.match(/\([\w=+.\/?&#_%:]+\)/)[0];
      return match.slice(1, match.length - 1);
    },
    getLinkName(str) {
      if (!this.isLink(str)) return '';
      return str.match(/[\w öüä]+/)[0];
    },
  },
  created() {
    Papa.parse(this.csvUrl, {
      download: true,
      complete: (results, file) => {
        this.csvRows = results.data;
        for( var i = 0; i < this.csvRows.length; i++){
            //Remove Empty Rows
            if ( this.csvRows[i].length <= 1) {
                this.csvRows.splice(i, 1);
            }
        }
      },
    });
  },
};
</script>

<style scoped>
th {
  cursor: pointer;
  text-align: left;
}
</style>
